import { latLng, MarkerProps } from "@tenforce/product-fields"
import { Fields } from "../../index"
import { DragEndEvent } from "leaflet"

export const locationArrayToMap = (
    locations: Fields.LocationField[],
): Map<string, Fields.LocationField> => {
    return new Map(
        locations.map((location) => {
            return [location.fieldId, location]
        }),
    )
}
const DEFAULT_BOUNDS = [
    [49.5, 4.5],
    [51.5, 6.5],
]

export const getDefaultBounds = (
    locations: Fields.LocationField[],
    shouldCalculateBounds: boolean,
): number[][] => {
    return shouldCalculateBounds
        ? [
              [
                  (locations[0].value?.latitude ?? 0) - 1,
                  (locations[0].value?.longitude ?? 0) - 1,
              ],
              [
                  (locations[0].value?.latitude ?? 0) + 1,
                  (locations[0].value?.longitude ?? 0) + 1,
              ],
          ]
        : DEFAULT_BOUNDS
}

export const convertLocationsToMarkers = (
    localLocations: Map<string, Fields.LocationField>,
    isLoading: boolean,
    onUpdateMarker: (newLocation: Fields.LocationField) => void,
): MarkerProps[] => {
    return Array.from(localLocations.values())
        .filter((location) => {
            return (
                location.value &&
                location.value.latitude &&
                location.value.longitude &&
                location.value.marker
            )
        })
        .map((location) => {
            const { fieldId, isReadOnly = false, value } = location
            const {
                latitude = -180,
                longitude = -180,
                marker,
            } = value ?? {
                marker: {
                    id: 0,
                    size: [0, 0],
                    imageSrc: "",
                    anchor: [0, 0],
                },
            }
            const { size, imageSrc, anchor } = marker
            return {
                id: fieldId,
                eventHandlers: {
                    dragend: (leafletEvent: DragEndEvent): void => {
                        const { lat, lng } = leafletEvent.target.getLatLng()
                        const newLocation = {
                            ...location,
                            value: {
                                ...value,
                                latitude: lat,
                                longitude: lng,
                                marker: { ...marker },
                            },
                        } as Fields.LocationField
                        onUpdateMarker(newLocation)
                    },
                },
                isReadOnly,
                position: latLng(latitude, longitude),
                riseOffset: 0,
                zIndexOffset: 0,
                icon: {
                    src: imageSrc,
                    anchor: anchor,
                    size: size,
                    extraClasses: isLoading ? "is-loading" : "",
                },
            }
        })
}
